<style scoped lang="scss">

</style>

<template>
  <div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeIn"
    >
      <div
        v-if="client.cid === null"
        class="fix_card_height d-flex justify-content-center align-items-center"
        :style="{height: `${customStyle.height}px`}"
      >
        <span class="card-text text-center text-muted font-italic">
          <font-awesome-icon :icon="faArrowAltCircleLeft"/>
          Choose a Site.
        </span>
        <!-- <span v-else class="card-text text-center text-muted font-italic">
          {{ client.cid }} selected.
        </span> -->
      </div>
      <Loading
        v-else-if="!loaded.clientHistory"
        mode="area"
        :style="{height: `${customStyle.height}px`}"
      />
      <vue-highcharts
        v-else
        ref="lineCharts"
        classname="p-0 m-0"
        :style="{height: `${customStyle.height - 5}px`}"
        :options="highStockOption"
        :highcharts="Highstock"
      />
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import VueHighcharts from 'vue2-highcharts'
import Highstock from 'highcharts/highstock'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faArrowAltCircleLeft } from '@fortawesome/fontawesome-free-solid'
import { getDbRef, offDbRef } from '@/firebaseRef'
import Loading from '@/components/Loading'

/* set highstock timezone */
Highstock.setOptions({
  global: {
    timezoneOffset: -8 * 60
  }
})

export default {
  props: {
    client: {
      type: Object,
      default: null
    },
    customStyle: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FontAwesomeIcon,
    Loading,
    VueHighcharts
  },
  data () {
    return {
      /* static value */
      DATA_PERIOD: 1, // data time range is limited in 1 hour from now
      DATA_FREQ: 3, // data frequecy is 3 seconds per data
      faArrowAltCircleLeft,
      Highstock,
      /* interval holder */
      chartTimer: null,
      /* highstock options */
      highStockOption: null,
      /* loaded state, true for loaded */
      loaded: {
        clientHistory: false
      },
      /* starting point (time) for realtime entry */
      activateChartTime: null,
      realtimEntry: {},
      holdingPoints: []
    }
  },
  computed: {
    test () {
      return this.Highstock
    }
  },
  watch: {
    client: function (current, previous) {
      /**
       * start retrieving the current client information,
       * or retrieve new data when site's status turned from disabled to enabled.
      */
      if (
        (current.cid != null && current.cid !== previous.cid) ||
        (current.cid != null && current.enabled && !previous.enabled)
      ) {
        this.highStockOption = null
        this.getClientHistory(current.cid)
        /* console.log(
          'Client changed, or status changed current.cid, current.enabled, previous.cid, previous.enabled',
          current.cid, current.enabled, previous.cid, previous.enabled
        ) */
      }
      /**
       * stop the previous listener (if there is one) when client changed,
       * or the site's status turned from enabled to disabled !!!
      */
      if (
        (previous.cid != null && current.cid !== previous.cid) ||
        (previous.cid != null && previous.enabled && !current.enabled)
      ) {
        offDbRef(`rxFixed/${previous.cid}`)
        offDbRef(`txFixed/${previous.cid}`)
        /* console.log(
          'Turn off when current.enabled, not null, current.cid, current.enabled, previous.cid, previous.enabled',
          current.cid, current.enabled, previous.cid, previous.enabled
        ) */
      }
    }
  },
  methods: {
    addPoint (...args) {
      const [index, x, y] = args
      this.$refs.lineCharts.getChart().series[index].addPoint([x, y], true, true)
    },
    assignOption (initData) {
      const title = this.client.sitename
      const { rxData, txData } = initData
      this.highStockOption = {
        tooltip: {
          padding: 4,
          useHTML: true,
          outside: true,
          formatter: function () {
            var content = `<table><tr><td colspan="2" style="text-align: center;">${moment(this.x).format('YYYY/MM/DD HH:mm:ss')}</td></tr><tr>`
            _.forEach(this.points, (value, key) => {
              if (value.y > 0) {
                content += `<td style="text-align: ${key ? 'right' : 'left'}; padding: ${key ? '0 0 0 4px' : '0 4px 0 0'}; color:${value.series.color}">${value.series.name}: ${value.y} bps</td>`
              } else {
                content += `<td style="text-align: ${key ? 'right' : 'left'}; padding: ${key ? '0 0 0 4px' : '0 4px 0 0'}; color:${value.series.color};">${value.series.name}: <span style="color: #F00;">Offline</span></td>`
              }
            })
            return `${content}</tr></table>`
          }
          // split: true
        },
        rangeSelector: {
          buttons: [{
            count: 1,
            type: 'minute',
            text: '1M'
          }, {
            count: 5,
            type: 'minute',
            text: '5M'
          }, {
            count: 10,
            type: 'minute',
            text: '10M'
          }, {
            count: 30,
            type: 'minute',
            text: '30M'
          }, {
            type: 'all',
            text: '1H'
          }],
          inputEnabled: false,
          selected: 0
        },
        legend: {
          enabled: true,
          align: 'right',
          verticalAlign: 'top'
        },
        lang: {
          noData: 'No Data'
        },
        noData: {
          style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
          }
        },
        chart: {
          animation: false
        },
        title: {
          text: title
        },
        navigator: {
          xAxis: {
            gridLineColor: '#505053'
          },
          series: [
            {color: '#1F6ED4'}, {color: '#ae63e4'}
          ]
        },
        exporting: {
          enabled: true
        },
        series: [{
          id: 'rxSeries',
          showInNavigator: true,
          color: '#1F6ED4',
          name: 'RX ',
          data: rxData || []
        }, {
          id: 'txSeries',
          showInNavigator: true,
          color: '#ae63e4',
          name: 'TX ',
          data: txData || []
        }]
      }
    },
    /* create data's amount is N and start at GENESIS */
    chartDataGenerator (N, genesis, freq) {
      return Array.from(
        { length: N },
        (v, i) => {
          return {
            createAt: genesis + (i + 1) * freq * 1000,
            size: 0
          }
        }
      )
    },
    /* fill data gaps from db */
    chartDataGapHandler (data, begin, range, freq) {
      data = _.orderBy(data, 'createAt', 'asc')
      let gapEntry, gapEnd
      let dataLength = data.length
      for (let i = 0; i <= dataLength; i++) {
        if (i === 0) {
          /* fill the gap between genesis to the first record */
          gapEntry = begin
          gapEnd = data[i].createAt
        } else if (i < dataLength) {
          /* fill the gap between each records */
          gapEntry = data[i - 1].createAt
          gapEnd = data[i].createAt
        } else {
          /* fill the gap between last record's createAt to current time */
          gapEntry = data[dataLength - 1].createAt
          gapEnd = begin + (range * 60 * 60 * 1000)
        }

        /* start filling gap */
        const gapRange = gapEnd - gapEntry
        const gapExist = gapRange > (freq * 1000 * 2) /* two freq gap then fill one */
        if (gapExist) {
          const N = Math.round(gapRange / (freq * 1000)) - 1
          const patch = this.chartDataGenerator(N, gapEntry, freq)
          data = _.concat(data, patch)
          // console.groupCollapsed(`${clientKey}/${subpath}'s Gap Info`)
          // console.log(`gapRange is ${gapRange}, so ${N} data will be added as below:`)
          // console.log(patch)
          // console.groupEnd()
        }
      }
      return data
    },
    async getClientHistory (cid) {
      console.log(`getClientHistory (${cid})`)
      this.loaded.clientHistory = false
      this.activateChartTime = Date.now() // to make the activate time below using the same value as defined here.
      const rxData = await this.getClientSnapshot(`rxFixed/${cid}`)
      const txData = await this.getClientSnapshot(`txFixed/${cid}`)
      const initData = { rxData, txData }
      this.assignOption(initData)
      this.loaded.clientHistory = true
      /* after history data and chart is loaded, activate realtime listenner */
      if (this.client.enabled) {
        this.triggerRealtimeClientSnapshot(`rxFixed/${cid}`)
        this.triggerRealtimeClientSnapshot(`txFixed/${cid}`)
      }
    },
    getClientSnapshot (path) {
      console.log(`getClientSnapshot(${path})`)
      const genesis = this.activateChartTime - this.DATA_PERIOD * 60 * 60 * 1000
      // console.log(genesis, path', genesis, path)

      /* generate the default data structure */
      const defaultData = this.chartDataGenerator(this.DATA_PERIOD * 60 * 60 / this.DATA_FREQ, genesis, this.DATA_FREQ)

      /* limit to last this.DATA_PERIOD hour data limitation */
      const clientRef = getDbRef(path).orderByChild('createAt').startAt(genesis)

      /* get current snapshot to load default line chart */
      return clientRef.once('value').then((snapshot) => {
        const record = snapshot.val()
        // console.log('record, size', record, _.size(record))

        if (record != null) {
          let recordArr = _.transform(record, (result, value, key) => {
            /* from Object structure to array */
            result.push({
              createAt: parseInt(value.createAt),
              size: parseInt(value.size * 8) /* byte to bits */
            })
          }, [])
          recordArr = this.chartDataGapHandler(recordArr, genesis, this.DATA_PERIOD, this.DATA_FREQ)
          recordArr = _.orderBy(recordArr, 'createAt', 'asc')
          // console.log('recordArr', recordArr)

          /* record the last record of path */
          this.realtimEntry[path] = recordArr[recordArr.length - 1].createAt

          /**
           * Generate valid data structure for highstock to show.
           * e.g. [['datetime', 'Bytes'], ['datetime', 'Bytes']...]
          */
          return _.transform(recordArr, (result, ele) => {
            result.push([ele.createAt, ele.size])
          }, [])
        } else {
          return _.transform(defaultData, (result, ele) => {
            result.push([ele.createAt, ele.size])
          }, [])
        }
      })
    },
    realtimeClientChildAddedEvent (snapshot, prevChildKey) {
      const path = _.join(_.take(snapshot.ref.path.pieces_, 2), '/')
      let { createAt, size } = snapshot.val()
      size *= 8 // byte to bits
      // console.log(`New ${ path } points: `, [createAt, size])

      const args = [path.includes('rxFixed') ? 0 : 1, createAt, size]
      /**
       * Add points when data flow begin if chart is ready,
       * if not ready, then hold those points and add up when it is.
       */
      if (this.$refs.lineCharts != null) {
        /* add holding point and clear them */
        while (this.holdingPoints.length > 0) {
          this.addPoint(...this.holdingPoints[0])
          this.holdingPoints = _.drop(this.holdingPoints) // remove the first one
        }
        this.addPoint(...args)
      } else {
        this.holdingPoints.push(args)
      }
    },
    triggerRealtimeClientSnapshot (path) {
      console.log(`triggerRealtimeClientSnapshot (${path})`)
      const entryPoint = this.realtimEntry[path]
      getDbRef(path)
        .orderByChild('createAt')
        .startAt(entryPoint)
        .on('child_added', this.realtimeClientChildAddedEvent, (err) => {
          console.error('triggerRealtimeClientSnapshot', err)
        })
    },
    load () {
      this.chartTimer = setInterval(() => {
        if (this.$refs.lineCharts != null) {
          this.addPoint()
        }
      }, 1000)
    }
  },
  mounted () {

  },
  beforeDestroy () {
    clearInterval(this.chartTimer)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RealtimeLineChart.vue